// @flow
import type {Action} from '../actions/types'
//import {AppEventsLogger} from 'react-native-fbsdk'
class AppEventsLogger {
  static logEvent(eventName, valueToSum, parameters) {
    console.log('[AppEventsLogger]', eventName, valueToSum, parameters)
  }
}


function track(action: Action): void {
  switch (action.type) {
  case 'LOGGED_IN':
    AppEventsLogger.logEvent('Login', 1, {source: action.source || ''})
    break

  case 'LOGGED_OUT':
    AppEventsLogger.logEvent('Logout', 1)
    break

  case 'SKIPPED_LOGIN':
    AppEventsLogger.logEvent('Skip login', 1)
    break

  case 'SIGNED_UP':
    AppEventsLogger.logEvent('Signup', 1)
    // AdWords Sign Up
    global.gtag('event', 'conversion', {
      send_to: 'AW-816000542/aJ9UCOD9hYEBEJ7cjIUD',
    })
    break

  default:
    // do nothing
  }
}

export default track



// WEBPACK FOOTER //
// ./src/store/track.js